import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TaskComponent } from '../task';

export declare type SelectData = {
  type?: string;
  question: string;
  options: string[];
  correct: string;
};

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css']
})
export class SelectComponent implements TaskComponent, OnInit {

  @Input() data: SelectData;
  @Output() taskSubmitted: EventEmitter<boolean> = new EventEmitter();
  public answer: string;
  public isAnswered: boolean = false;
  
  constructor() { }

  ngOnInit() {
  }

  submit() {
    if(this.answer == this.data.correct) {
      this.taskSubmitted.emit(true);
    } else {
      this.taskSubmitted.emit(false);
    }
    this.isAnswered = true;
  }

}
